import {mapActions, mapGetters, mapMutations} from 'vuex'
import _ from 'lodash';
import moment from "moment";

import paginatorRequest from '@/components/paginator-request/index.vue'
import {CONSTANTS} from '@/config/constants';
import Vue from "vue";

export default {
  name: 'dashboardTable',
  //---components
  components: {
    paginatorRequest
  },
  //---data
  data () {
    return {
      currentTypeId: null,
      dashboardFilters: [
        {
          id: 0,
          val: null
        },
        {
          id: 1,
          val: null
        },
        {
          id: 2,
          val: null
        }
      ]
    }
  },
  //---hooks
  created: function () {
    this.currentTypeId = this.dashboardListMeta.currentTypeId;
    this.dashboardListMeta.list.forEach((item, index) => {
      this.dashboardFilters[index].val = item.params[0].val;
    });
  },
  computed: {
    ...mapGetters({
      appSize: 'APP/appSize',
      dashboardLists: 'DASHBOARD/dashboardLists',
      dashboardListMeta: 'DASHBOARD/dashboardListMeta',
      dashboardRealtyList: 'DASHBOARD/dashboardRealtyList',
      dashboardAnalystList: 'DASHBOARD/dashboardAnalystList',

    })
  },
  //---methods
  methods: {
    ...mapMutations({
      loaderFlag: 'APP/APP_LOADER_FLAG_TOGGLE',
      setDashboardListMeta: 'DASHBOARD/DASHBOARD_LIST_META_SET',
      setDashboardProperty: 'DASHBOARD/DASHBOARD_PROPERTY_SET',
    }),
    ...mapActions({
      getDashboardList: 'DASHBOARD/DASHBOARD_LIST_REQUEST_GET',
    }),
    getPropertyStatus(status_id) {
      return _.find(CONSTANTS.APP_LISTING_STATUS, (item) => {
        return item.id === status_id;
      }).title;
    },
    getTTM(date) {
      let days = moment().diff(moment(date), 'days');
      return days === 1 ? days + ' day ': days + ' days'
    },
    gotoDashboardProperty(property) {
      let listMeta = _.cloneDeep(this.dashboardListMeta);
      listMeta.currentTypeId = this.currentTypeId;
      this.setDashboardListMeta(listMeta);

      this.setDashboardProperty(property);
      this.$router.push( {
        name: 'dashboard-property',
        params: {
          listing_id: property.id
        }
      });
    },
    changeFilter() {
      this.loaderFlag(true);
      let listMeta = _.cloneDeep(this.dashboardListMeta);
      listMeta.list[this.currentTypeId].pageId = 1;
      listMeta.list[this.currentTypeId].params[0].val = this.dashboardFilters[this.currentTypeId].val;
      this.setDashboardListMeta(listMeta);

      this.getDashboardList({typeId: this.currentTypeId}).finally(()=>{
        this.loaderFlag(false);
      });
    },
    getPage(pageId) {
      this.loaderFlag(true);

      let listMeta = _.cloneDeep(this.dashboardListMeta);
      listMeta.list[this.currentTypeId].pageId = pageId;
      this.setDashboardListMeta(listMeta);

      this.getDashboardList({typeId: this.currentTypeId}).finally(()=>{
        this.loaderFlag(false);
      });
    },
  }
}